import PermissionSection from 'components/permission/PermissionSection';
import { PermissionSchema } from 'services/security';
import { Permissions } from 'entities/dashboard';
import Button from 'components/Button';

import {
  InvitePersonsProps,
  PermissionType,
  Person,
} from '../invitePersonsSlice';

export const mappedPersonsAccess = (persons: Person[]) =>
  persons.filter((p) => p.hubCreateUser).map((p) => p.businessesPersonsXREFId);

export const getModalActions = (
  currentTab,
  t,
  onClick,
  isLoading,
  permissions,
) => {
  if (currentTab === 0) {
    return (
      <div className="flex justify-end">
        <PermissionSection permission={Permissions.invite} showPopover edit>
          <Button
            onClick={onClick}
            loading={isLoading}
            disabled={!permissions.edit}
          >
            {t('dashboard:invitePersons.buttons.send')}
          </Button>
        </PermissionSection>
      </div>
    );
  }

  return null;
};

export const getPermissionCodeWithoutType = (permission: PermissionSchema) => {
  return permission.permissions_Code
    .toLowerCase()
    .replace(`_${PermissionType.view}`, '')
    .replace(`_${PermissionType.edit}`, '');
};

export const getMappedPermissions = (
  data: InvitePersonsProps,
  isCapitalProductActive: boolean,
) => {
  const { permissionType, personPermissions, permissions } = data;

  const viewPermissions = personPermissions.filter((p) =>
    p.permissions_Code.toLowerCase().endsWith(`_${PermissionType.view}`),
  );

  const editPermissions = personPermissions.filter((p) =>
    p.permissions_Code.toLowerCase().endsWith(`_${PermissionType.edit}`),
  );

  const selectedPermissions =
    permissionType === PermissionType.view
      ? viewPermissions
      : [
          ...permissions.view.filter((p) =>
            editPermissions.find(
              (e) =>
                getPermissionCodeWithoutType(e) ===
                getPermissionCodeWithoutType(p),
            ),
          ),
          ...editPermissions,
        ];

  // Webcargo configuration tab requires bank integration permission
  if (isCapitalProductActive) {
    if (
      selectedPermissions.some(
        (p) =>
          p.permissions_Code.toLowerCase() ===
          `${Permissions.configuration}_${PermissionType.view}`.toLowerCase(),
      )
    ) {
      const bankPermission = permissions.view.find(
        (p) =>
          p.permissions_Code.toLowerCase() ===
          `${Permissions.bankIntegration}_${PermissionType.view}`.toLowerCase(),
      );

      if (bankPermission) {
        selectedPermissions.push(bankPermission);
      }
    }

    if (
      selectedPermissions.some(
        (p) =>
          p.permissions_Code.toLowerCase() ===
          `${Permissions.configuration}_${PermissionType.edit}`.toLowerCase(),
      )
    ) {
      const bankPermission = permissions.edit.find(
        (p) =>
          p.permissions_Code.toLowerCase() ===
          `${Permissions.bankIntegration}_${PermissionType.edit}`.toLowerCase(),
      );

      if (bankPermission) {
        selectedPermissions.push(bankPermission);
      }
    }
  }

  return Array.from(
    new Set(selectedPermissions.map((p) => p.security_PermissionsId)),
  );
};
